<template>
  <div class="body">
    <!--快捷入口组件 -->
    <div class="quickly">
      <Quick @sendId="acceptId"></Quick>
    </div>
  </div>
</template>
<script>
import Quick from "./common/Quick.vue";
export default {
  components: {
    Quick,
  },
  data() {
    return {};
  },

  methods: {
    //接收子组件传递的数据
    acceptId(data) {
      let id = data;
      console.log("父组件传递的id是：", id);
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  z-index: 9999;
  position: fixed;
  right: 0px;
}
</style>
